module.exports = __webpack_public_path__ + "img/e087d59.jpg";